/* tslint:disable */
/* eslint-disable */
/* @relayHash 7dbf1610114fb2068b70f087c49a0785 */

import { ConcreteRequest } from "relay-runtime";
export type CreateVocabAnswerInput = {
    studyRecordId: string;
    exerciseId: string;
    responseTerm: VocabAnswerTermInput;
    correctTerm: VocabAnswerTermInput;
    isCorrect: boolean;
    clientMutationId?: string | null;
};
export type VocabAnswerTermInput = {
    word: string;
    definition?: string | null;
    imageId?: string | null;
};
export type CreateVocabAnswerMutationVariables = {
    input: CreateVocabAnswerInput;
};
export type CreateVocabAnswerMutationResponse = {
    readonly createVocabAnswer: {
        readonly answer: {
            readonly id: string;
        } | null;
    } | null;
};
export type CreateVocabAnswerMutation = {
    readonly response: CreateVocabAnswerMutationResponse;
    readonly variables: CreateVocabAnswerMutationVariables;
};



/*
mutation CreateVocabAnswerMutation(
  $input: CreateVocabAnswerInput!
) {
  createVocabAnswer(input: $input) {
    answer {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateVocabAnswerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createVocabAnswer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateVocabAnswerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "answer",
        "storageKey": null,
        "args": null,
        "concreteType": "VocabAnswer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateVocabAnswerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateVocabAnswerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateVocabAnswerMutation",
    "id": null,
    "text": "mutation CreateVocabAnswerMutation(\n  $input: CreateVocabAnswerInput!\n) {\n  createVocabAnswer(input: $input) {\n    answer {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '1a05c8e4c008d72718f77d0b0193783b';
export default node;
